import { parsePhoneNumberWithError } from 'libphonenumber-js';
import { emailRegex, normalizeEmail } from '@bariendo/lib/email-validations';
import { normalizePhoneNumber } from '@bariendo/lib/phone-validations';

export { normalizeEmail };

// Phone validation reused by SmartEditableField and PhoneEditableField
export function checkPhoneValidation(phoneNumber: string): string | undefined {
  if (!phoneNumber || phoneNumber.trim().length === 0) {
    return undefined; // Don't show error for empty
  }

  // Only validate if the phone number has enough digits to be considered "complete"
  // Extract digits only to check length
  const digitsOnly = phoneNumber.replace(/\D/g, '');

  // If it contains letters, it's invalid (don't even wait for the user to finish typing)
  if (/[a-zA-Z]/.test(phoneNumber)) {
    return 'Invalid phone number';
  }

  // If less than 11 (US phone number format, excluding country code) digits, don't show error yet (user is still typing)
  if (digitsOnly.length < 11) {
    return undefined;
  }

  try {
    const parsed = parsePhoneNumberWithError(phoneNumber);
    if (!parsed.isValid()) {
      return 'Invalid phone number';
    }
    return undefined;
  } catch (_error) {
    return 'Invalid phone number';
  }
}

export function checkFaxValidation(faxNumber: string): string | undefined {
  if (!faxNumber || faxNumber.trim().length === 0) {
    return undefined;
  }

  if (/[a-zA-Z]/.test(faxNumber)) {
    return 'Invalid fax number';
  }

  const digitsOnly = faxNumber.replace(/\D/g, '');
  if (digitsOnly.length < 10) {
    return undefined;
  }

  try {
    const normalized = normalizePhoneNumber(faxNumber);
    const parsed = parsePhoneNumberWithError(normalized);
    if (!parsed.isValid()) {
      return 'Invalid fax number';
    }
    return undefined;
  } catch (_error) {
    return 'Invalid fax number';
  }
}

// Email validation reused by SmartEditableField and EmailEditableField
export function checkEmailValidation(email: string): string | undefined {
  if (!email || email.trim().length === 0) {
    return undefined; // Don't show error for empty
  }

  const trimmed = email.trim();

  // Only validate if it looks like the user is done typing
  const parts = trimmed.split('@');
  if (email.length < 4 && (parts.length !== 2 || parts[1].length < 2)) {
    return undefined; // Still typing the domain
  }

  // Basic email validation
  if (!emailRegex.test(trimmed)) {
    return 'Invalid email address';
  }

  return undefined;
}
